// import { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { RBTable } from "@pallassystems/react-bootstrap-table";
// import {
//   Row,
//   Col,
//   Card,
//   Button,
//   Badge,
//   Modal,
//   Form,
//   Table,
// } from "react-bootstrap";
// import Breadcrumb from "app/components/Breadcrumb";
// import { axios } from "fake-db/mock";
// import api from "app/services/api";

// // ─── Validation helpers ────────────────────────────────────────────────────
// // Rule: lightweight RFC 5322-style email check
// const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// // Rule: phone 7–15 digits (ignoring spaces, dashes, parentheses)
// const isValidPhone = (val) => /^\d{7,15}$/.test(val.replace(/[\s\-().+]/g, ""));
// // Rule: date must be a valid ISO date and not in the future
// const isValidDate = (val) => val && !isNaN(new Date(val).getTime());
// const isNotFuture = (val) => val && new Date(val) <= new Date();
// // ─────────────────────────────────────────────────────────────────────────────

// export default function EmployeeTable() {
//   const navigate = useNavigate();
//   const [showFilter, setShowFilter] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [showEyeMenu, setShowEyeMenu] = useState(false);
//   const [disabledCols, setDisabledCols] = useState({
//     employee: false,
//     company: false,
//     contact: false,
//     action: false,
//   });
//   const [companies, setCompanies] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [locations, setLocations] = useState([]);
//   const [shifts, setShifts] = useState([]);
//   const [roles, setRoles] = useState([]);

//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     office_shift_id: "",
//     email: "",
//     contact_no: "",
//     password: "",
//     confirm_password: "",
//     username: "",
//     date_of_birth: "",
//     gender: "",
//     department_id: "",
//     designation_id: "",
//     role_users_id: "",
//     joining_date: "",
//     state: "",
//     attendance_type: "",
//     location_id: "",
//   });

//   // 🔥 ADD THESE STATES TOP ME
//   const [search, setSearch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const [showCheckbox, setShowCheckbox] = useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);
//   // Tracks per-field error messages for the Add Employee modal
//   const [modalErrors, setModalErrors] = useState({});
//   const [modalImageError, setModalImageError] = useState("");
//   const [modalImageFile, setModalImageFile] = useState(null);

//   // ---------- Validate Add Employee modal ----------
//   const validateModal = () => {
//     const errs = {};

//     // Rule: first name required, max 50 chars
//     if (!formData.first_name?.trim())
//       errs.first_name = "First name is required";
//     else if (formData.first_name.trim().length > 50)
//       errs.first_name = "First name must not exceed 50 characters";

//     // Rule: last name required, max 50 chars
//     if (!formData.last_name?.trim()) errs.last_name = "Last name is required";
//     else if (formData.last_name.trim().length > 50)
//       errs.last_name = "Last name must not exceed 50 characters";

//     // Rule: email required and valid format
//     if (!formData.email?.trim()) errs.email = "Email is required";
//     else if (!EMAIL_REGEX.test(formData.email.trim()))
//       errs.email = "Please enter a valid email address";

//     // Rule: phone optional but 7–15 digits if provided
//     if (formData.contact_no && !isValidPhone(formData.contact_no))
//       errs.contact_no = "Phone must be 7–15 digits";

//     // Rule: username required, 3–50 chars
//     if (!formData.username?.trim()) errs.username = "Username is required";
//     else if (formData.username.trim().length < 3)
//       errs.username = "Username must be at least 3 characters";
//     else if (formData.username.trim().length > 50)
//       errs.username = "Username must not exceed 50 characters";

//     // Rule: date of birth must be a past date
//     if (formData.date_of_birth) {
//       if (!isValidDate(formData.date_of_birth))
//         errs.date_of_birth = "Please enter a valid date";
//       else if (!isNotFuture(formData.date_of_birth))
//         errs.date_of_birth = "Date of birth cannot be a future date";
//     }

//     // Rule: joining date required, must not be in the future
//     if (!formData.joining_date)
//       errs.joining_date = "Date of joining is required";
//     else if (!isValidDate(formData.joining_date))
//       errs.joining_date = "Please enter a valid date";
//     else if (new Date(formData.joining_date) > new Date())
//       errs.joining_date = "Joining date cannot be a future date";

//     // Rule: required dropdowns — must select a value
//     if (!formData.department_id) errs.department_id = "Department is required";
//     if (!formData.designation_id)
//       errs.designation_id = "Designation is required";
//     if (!formData.office_shift_id)
//       errs.office_shift_id = "Office shift is required";
//     if (!formData.role_users_id) errs.role_users_id = "Role is required";
//     if (!formData.location_id) errs.location_id = "Geo location is required";

//     // Rule: gender must be from allowed values
//     const validGenders = ["", "Male", "Female"];
//     if (!formData.gender || !validGenders.includes(formData.gender))
//       errs.gender = "Please select a gender";

//     // Rule: attendance type must be from allowed values
//     const validAttendance = ["Daily", "Hourly"];
//     if (!validAttendance.includes(formData.attendance_type))
//       errs.attendance_type = "Please select attendance type";

//     setModalErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   // ---------- Validate image file upload ----------
//   const handleModalImageChange = (e) => {
//     const file = e.target.files[0];
//     setModalImageFile(null);
//     setModalImageError("");
//     if (!file) return;
//     // Rule: only image MIME types allowed
//     const allowedMimes = ["image/jpeg", "image/png", "image/gif", "image/jpg"];
//     if (!allowedMimes.includes(file.type)) {
//       setModalImageError("Only jpg, jpeg, png, gif files are allowed");
//       e.target.value = "";
//       return;
//     }
//     // Rule: max 5 MB
//     if (file.size > 5 * 1024 * 1024) {
//       setModalImageError("Image must be less than 5MB");
//       e.target.value = "";
//       return;
//     }
//     setModalImageFile(file);
//   };

//   const columns = useMemo(
//     () => [
//       { accessorKey: "index", header: "No" },
//       { accessorKey: "employee", header: "Employee", searchable: true },
//       { accessorKey: "company", header: "Company", searchable: true },
//       { accessorKey: "contact", header: "Contact", searchable: true },

//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "200px", textAlign: "center" },
//         Cell: ({ row }) => {
//           const item = row?.original || {};
//           const userId = item.id;

//           return (
//             <div className="d-flex align-items-center gap-2">
//               {/* View Button */}
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() =>
//                   navigate(`/employees/${item.id}/general`, { state: item })
//                 }
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>

//               {/* Delete Button */}
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "28px",
//                   height: "28px",
//                   backgroundColor: "#c4302b",
//                   border: "none",
//                   borderRadius: "4px",
//                 }}
//                 onClick={() => alert("Deleting user ID: " + userId)}
//               >
//                 <i className="i-Close-Window text-white"></i>
//               </Button>

//               {/* Pdf Button */}
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "28px",
//                   height: "28px",
//                   backgroundColor: "#ffc107",
//                   border: "none",
//                   borderRadius: "4px",
//                 }}
//                 onClick={() => alert("PDF for user ID: " + userId)}
//               >
//                 <i className="i-File-Horizontal-Text text-18 text-white"></i>
//               </Button>

//               {/* Map Button */}
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "28px",
//                   height: "28px",
//                   backgroundColor: "#007bff",
//                   border: "none",
//                   borderRadius: "4px",
//                 }}
//                 onClick={() => alert("Map for user ID: " + userId)}
//               >
//                 <i className="i-Map-Marker text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//     [],
//   );

//   useEffect(() => {
//     api
//       .get("/api/company/all")
//       .then((res) => {
//         setCompanies(res.data.data || []);
//       })
//       .catch((err) => {
//         console.error("Company Fetch Error:", err);
//       });
//   }, []);

//   useEffect(() => {
//     api
//       .get("/api/departments")
//       .then((res) => {
//         setDepartments(res.data.departments || []);
//       })
//       .catch((err) => {
//         console.error("Department Fetch Error:", err);
//       });
//   }, []);

//   useEffect(() => {
//     if (!formData.department_id) return;

//     api
//       .get(`/api/designations?department_id=${formData.department_id}`)
//       .then((res) => {
//         setDesignations(res.data.designations || []);
//       })
//       .catch((err) => {
//         console.error("Designation Fetch Error:", err);
//       });
//   }, [formData.department_id]);

//   useEffect(() => {
//     api
//       .get("/api/office-shifts")
//       .then((res) => {
//         console.log("SHIFT API RESPONSE:", res.data);
//         // Safely extract array
//         const shiftsArray = Array.isArray(res.data)
//           ? res.data
//           : res.data?.data || [];
//         setShifts(shiftsArray);
//       })
//       .catch((err) => {
//         console.error("Shift Fetch Error:", err);
//         setShifts([]); // fallback to empty array
//       });
//   }, []);

//   useEffect(() => {
//     api
//       .get("/api/roles/all")
//       .then((res) => {
//         setRoles(res.data.data || []);
//       })
//       .catch((err) => {
//         console.error("Role Fetch Error:", err);
//       });
//   }, []);

//   useEffect(() => {
//     fetchEmployees();
//   }, []);

//   useEffect(() => {
//     api
//       .get("/api/geo-locations")
//       .then((res) => {
//         console.log("GEO API RESPONSE:", res.data); // 👈 ADD THIS
//         setLocations(res.data.data || []);
//       })
//       .catch((err) => {
//         console.error("Geo location error", err);
//       });
//   }, []);

//   const fetchEmployees = () => {
//     api
//       .get("/api/employees")
//       .then((res) => {
//         const data = res.data.data || [];
//         console.log(data);
//         const userList = data.map((item, ind) => ({
//           id: item.id,
//           index: ind + 1,
//           employee: item.employee,
//           company: item.company || "N/A",
//           department: item.department || "N/A",
//           designation: item.designation || "N/A",
//           role: item.role || "N/A",
//           contact: item.email || item.contact_no || "N/A",
//           is_active: item.is_active, // ✅ THIS WAS MISSING
//         }));

//         setUsers(userList);
//       })
//       .catch((err) => {
//         console.error("Employee Fetch Error:", err);
//         setUsers([]);
//       });
//   };
//   // ✅ Single delete
//   const handleDelete = (item) => {
//     if (!window.confirm(`Delete "${item.employee}"?`)) return;

//     api
//       .delete(`/api/employees/${item.id}`)
//       .then(() => {
//         alert("Deleted Successfully ✅");
//         fetchEmployees();
//       })
//       .catch((err) => console.error(err));
//   };

//   // ✅ Bulk delete
//   const handleBulkDelete = () => {
//     if (selectedRows.length === 0) {
//       alert("Select at least 1 employee ❌");
//       return;
//     }

//     if (!window.confirm("Delete selected employees?")) return;

//     api
//       .post("/api/employees/delete", { ids: selectedRows })
//       .then(() => {
//         alert("Bulk Deleted ✅");
//         setSelectedRows([]);
//         setShowCheckbox(false);
//         fetchEmployees();
//       })
//       .catch((err) => console.error(err));
//   };

//   const filteredUsers = users.filter((item) =>
//     item.employee?.toLowerCase().includes(search.toLowerCase()),
//   );

//   const totalRows = filteredUsers.length;
//   const totalPages =
//     rowsPerPage >= totalRows ? 1 : Math.ceil(totalRows / rowsPerPage);

//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const paginatedUsers = filteredUsers.slice(
//     startIndex,
//     startIndex + rowsPerPage,
//   );

//   const handleToggleStatus = async (item) => {
//     try {
//       const newStatus = item.is_active === 1 ? 0 : 1;

//       await api.put(`/api/employees/${item.id}/status`, {
//         is_active: newStatus,
//       });

//       // 🔥 instant UI update
//       setUsers((prev) =>
//         prev.map((u) =>
//           u.id === item.id ? { ...u, is_active: newStatus } : u,
//         ),
//       );
//     } catch (err) {
//       console.error(err);
//       alert("Status update failed ❌");
//     }
//   };

//   return (
//     <section>
//       <Breadcrumb
//         routeSegments={[
//           { name: "Dashboard", path: "/" },
//           { name: "Employee", path: "/employees/EmployeesList" },
//           { name: "Employee List" },
//         ]}
//       />

//       <div className="mb-3">
//         <Row>
//           <Col lg={12}>
//             <Card body>
//               {/* Top Button Row */}
//               <div className="d-flex justify-content-between align-items-center flex-wrap">
//                 {/* Left Buttons */}
//                 <div className="d-flex flex-wrap gap-2">
//                   <Button
//                     className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
//                     style={{ backgroundColor: "#663399" }}
//                     onClick={() => setShowModal(true)}
//                   >
//                     <span className="ul-btn__icon">
//                       <i className="i-Business-Mens text-18"></i>
//                     </span>
//                     <span className="ul-btn__text ml-2">Add Employee</span>
//                   </Button>

//                   {/* <Button
//                     style={{ backgroundColor: "#c4302b" }}
//                     onClick={() => {
//                       if (showCheckbox && selectedRows.length > 0) {
//                         handleBulkDelete();
//                       } else {
//                         setShowCheckbox(true);
//                       }
//                     }}
//                   >
//                     Bulk Delete
//                   </Button> */}

//                   {/* <Button
//                     className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
//                     style={{ backgroundColor: "#078ea0ff" }}
//                     onClick={() => setShowFilter(!showFilter)}
//                   >
//                     <span className="ul-btn__icon">
//                       <i className="i-Filter-2 text-18"></i>
//                     </span>
//                     <span className="ul-btn__text ml-2">Filter</span>
//                   </Button> */}
//                 </div>

//                 {/* Right Buttons */}
//                 <div className="d-flex gap-2 mt-2 mt-md-0">
//                   <Button
//                     className="btn-icon d-flex align-items-center justify-content-center"
//                     style={{
//                       width: 36,
//                       height: 36,
//                       backgroundColor: "#f44336",
//                       border: "none",
//                     }}
//                   >
//                     <i className="i-File-Horizontal-Text text-18 text-white"></i>
//                   </Button>
//                   <Button
//                     className="btn-icon d-flex align-items-center justify-content-center"
//                     style={{
//                       width: 36,
//                       height: 36,
//                       backgroundColor: "#ffc107",
//                       border: "none",
//                     }}
//                   >
//                     <i className="i-File-CSV text-18 text-white"></i>
//                   </Button>
//                   <Button
//                     className="btn-icon d-flex align-items-center justify-content-center"
//                     style={{
//                       width: 36,
//                       height: 36,
//                       backgroundColor: "#007bff",
//                       border: "none",
//                     }}
//                   >
//                     <i className="i-Billing text-18 text-white"></i>
//                   </Button>
//                   <div style={{ position: "relative" }}>
//                     <Button
//                       onClick={() => setShowEyeMenu(!showEyeMenu)}
//                       style={{
//                         width: "48px",
//                         height: "36px",
//                         backgroundColor: "#7e57c2",
//                         border: "none",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: "6px",
//                         padding: 0,
//                       }}
//                     >
//                       {/* Eye icon */}
//                       <i
//                         className="i-Eye text-white"
//                         style={{ fontSize: "18px" }}
//                       ></i>

//                       {/* ▼ Triangle Arrow (exact screenshot style) */}
//                       <span
//                         style={{
//                           width: 0,
//                           height: 0,
//                           borderLeft: "5px solid transparent",
//                           borderRight: "5px solid transparent",
//                           borderTop: "6px solid #fff",
//                           marginTop: "2px",
//                         }}
//                       ></span>
//                     </Button>

//                     {/* Dropdown */}
//                     {showEyeMenu && (
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "44px",
//                           right: 0,
//                           width: "180px",
//                           backgroundColor: "#7e57c2",
//                           borderRadius: "10px",
//                           boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
//                           padding: "6px 0",
//                           zIndex: 9999,
//                         }}
//                       >
//                         {["Employee", "Company", "Contact", "action"].map(
//                           (item) => (
//                             <div
//                               key={item}
//                               style={{
//                                 padding: "10px 16px",
//                                 color: "#fff",
//                                 fontSize: "15px",
//                                 cursor: "pointer",
//                               }}
//                               onMouseEnter={(e) =>
//                                 (e.currentTarget.style.background =
//                                   "rgba(255,255,255,0.15)")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.background =
//                                   "transparent")
//                               }
//                             >
//                               {item}
//                             </div>
//                           ),
//                         )}
//                       </div>
//                     )}
//                   </div>

//                   {/* <Button
//                     className="btn-icon d-flex align-items-center justify-content-center"
//                     style={{
//                       width: 36,
//                       height: 36,
//                       backgroundColor: "#663399",
//                       border: "none",
//                     }}
//                   >
//                     <i className="i-Eye text-18 text-white"></i>
//                   </Button> */}
//                 </div>
//               </div>

//               {/* Filter Row - appears below the buttons */}
//               {showFilter && (
//                 <Card className="mt-3 p-3">
//                   <Row className="align-items-center g-2">
//                     <Col md={3}>
//                       <Form.Select
//                         value={formData.company_id}
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             company_id: e.target.value,
//                             department_id: "",
//                           })
//                         }
//                       >
//                         <option value="">Select Company...</option>
//                         {companies.map((item) => (
//                           <option key={item.id} value={item.id}>
//                             {item.company_name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={3}>
//                       <Form.Select
//                         value={formData.department_id}
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             department_id: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Select Department...</option>
//                         {departments.map((item) => (
//                           <option key={item.id} value={item.id}>
//                             {item.department_name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={3}>
//                       <Form.Select
//                         value={formData.designation_id || ""}
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             designation_id: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Select Designation...</option>
//                         {designations.map((item) => (
//                           <option key={item.id} value={item.id}>
//                             {item.designation_name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={2}>
//                       <Form.Select
//                         value={formData.office_shift_id || ""}
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             office_shift_id: e.target.value, // ✅ correct key
//                           })
//                         }
//                       >
//                         <option value="">Select Office Shift...</option>
//                         {shifts.map((item) => (
//                           <option key={item.id} value={item.id}>
//                             {item.shift_name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={1}>
//                       <Button variant="dark" className="w-100">
//                         GET
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Card>
//               )}
//             </Card>
//           </Col>
//         </Row>
//       </div>

//       <Card body>
//         <div className="d-flex justify-content-between align-items-center mb-2">
//           <Card.Title>Employee Table</Card.Title>

//           {/* 🔍 SEARCH */}
//           <input
//             type="text"
//             placeholder="Search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{ width: "250px", height: "36px" }}
//           />
//         </div>

//         <Table bordered hover>
//           <thead style={{ background: "#cfc7d9" }}>
//             <tr>
//               {showCheckbox && (
//                 <th>
//                   <input
//                     type="checkbox"
//                     checked={
//                       paginatedUsers.length > 0 &&
//                       paginatedUsers.every((u) => selectedRows.includes(u.id))
//                     }
//                     onChange={(e) => {
//                       if (e.target.checked) {
//                         setSelectedRows(paginatedUsers.map((u) => u.id));
//                       } else {
//                         setSelectedRows([]);
//                       }
//                     }}
//                   />
//                 </th>
//               )}
//               <th>No</th>
//               <th>Employee</th>
//               <th>Company</th>
//               <th>Department</th>
//               <th>Designation</th>
//               <th>Role</th>
//               <th>Contact</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {paginatedUsers.map((item, index) => {
//               return (
//                 <tr key={item.id}>
//                   {showCheckbox && (
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selectedRows.includes(item.id)}
//                         onChange={(e) => {
//                           if (e.target.checked) {
//                             setSelectedRows((prev) => [...prev, item.id]);
//                           } else {
//                             setSelectedRows((prev) =>
//                               prev.filter((id) => id !== item.id),
//                             );
//                           }
//                         }}
//                       />
//                     </td>
//                   )}

//                   <td>{startIndex + index + 1}</td>
//                   <td>{item.employee}</td>
//                   <td>{item.company}</td>
//                   <td>{item.department}</td>
//                   <td>{item.designation}</td>

//                   <td>
//                     <Badge bg="primary">{item.role}</Badge>
//                   </td>

//                   <td>{item.contact}</td>

//                   <td>
//                     <div className="d-flex align-items-center gap-2">
//                       <Form.Check
//                         type="switch"
//                         id={`status-${item.id}`}
//                         checked={item.is_active === 1}
//                         onChange={() => handleToggleStatus(item)}
//                       />
//                       <span
//                         style={{
//                           fontWeight: "500",
//                           color: item.is_active === 1 ? "green" : "red",
//                         }}
//                       >
//                         {item.is_active === 1 ? "Active" : "Inactive"}
//                       </span>
//                     </div>
//                   </td>

//                   <td>
//                     <div className="d-flex gap-2">
//                       <Button
//                         style={{ background: "#663399", border: "none" }}
//                         onClick={() =>
//                           navigate(`/employees/${item.id}/general`, {
//                             state: item,
//                           })
//                         }
//                       >
//                         <i className="i-Edit text-white"></i>
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </Table>
//         {/* 🔥 PAGINATION */}
//         <div className="d-flex justify-content-end align-items-center mt-3">
//           <span className="me-2">Rows per page</span>

//           <Form.Select
//             value={rowsPerPage}
//             onChange={(e) => {
//               const val =
//                 e.target.value === "all"
//                   ? filteredUsers.length
//                   : Number(e.target.value);
//               setRowsPerPage(val);
//               setCurrentPage(1);
//             }}
//             style={{ width: "90px", marginRight: "15px" }}
//           >
//             <option value={5}>5</option>
//             <option value={20}>20</option>
//             <option value="all">All</option>
//           </Form.Select>

//           <span className="me-3">
//             {startIndex + 1}-{Math.min(startIndex + rowsPerPage, totalRows)} of{" "}
//             {totalRows}
//           </span>

//           {/* FIRST */}
//           <Button
//             style={{
//               backgroundColor: "#7d5bbe",
//               border: "none",
//               marginRight: "5px",
//             }}
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage(1)}
//           >
//             ⏮
//           </Button>

//           {/* PREVIOUS */}
//           <Button
//             style={{
//               backgroundColor: "#7d5bbe",
//               border: "none",
//               marginRight: "5px",
//             }}
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage(currentPage - 1)}
//           >
//             ◀
//           </Button>

//           {/* NEXT */}
//           <Button
//             style={{
//               backgroundColor: "#7d5bbe",
//               border: "none",
//               marginRight: "5px",
//             }}
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage(currentPage + 1)}
//           >
//             ▶
//           </Button>

//           {/* LAST */}
//           <Button
//             style={{ backgroundColor: "#7d5bbe", border: "none" }}
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage(totalPages)}
//           >
//             ⏭
//           </Button>
//         </div>
//       </Card>

//       {/* Add Employee Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Add Employee</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Form>
//             <Row>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     First Name <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="First Name"
//                     value={formData.first_name || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, first_name: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.first_name}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.first_name}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Last Name <span className="text-danger">*</span>
//                   </Form.Label>

//                   <Form.Control
//                     type="text"
//                     placeholder="Last Name"
//                     value={formData.last_name || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, last_name: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.last_name}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.last_name}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Staff Id *</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Staff Id"
//                     value={formData.staff_id || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, staff_id: e.target.value })
//                     }
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Email <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="email"
//                     placeholder="example@example.com"
//                     value={formData.email || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, email: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.email}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.email}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Phone</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Phone"
//                     value={formData.contact_no || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, contact_no: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.contact_no}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.contact_no}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Date Of Birth</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={formData.date_of_birth || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         date_of_birth: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.date_of_birth}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.date_of_birth}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Gender <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.gender || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, gender: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.gender}
//                   >
//                     <option value="">Select Gender...</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.gender}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Geo Location <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.location_id || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         location_id: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.location_id}
//                   >
//                     <option value="">Select Location...</option>
//                     {locations.map((item) => (
//                       <option key={item.value} value={item.value}>
//                         {item.label}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.location_id}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Department <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.department_id}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         department_id: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.department_id}
//                   >
//                     <option value="">Select Department...</option>
//                     {departments.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.department_name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.department_id}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Designation <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.designation_id || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         designation_id: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.designation_id}
//                   >
//                     <option value="">Select Designation...</option>
//                     {designations.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.designation_name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.designation_id}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Office Shift <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.office_shift_id || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         office_shift_id: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.office_shift_id}
//                   >
//                     <option value="">Select Office Shift...</option>
//                     {shifts.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.shift_name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.office_shift_id}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Username <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Username"
//                     value={formData.username || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, username: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.username}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.username}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Role <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.role_users_id || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         role_users_id: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.role_users_id}
//                   >
//                     <option value="">Select Role...</option>
//                     {roles.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.role_users_id}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Password *</Form.Label>
//                   <Form.Control
//                     type="password"
//                     placeholder="Password"
//                     value={formData.password || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, password: e.target.value })
//                     }
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Confirm Password *</Form.Label>
//                   <Form.Control
//                     type="password"
//                     placeholder="Confirm Password"
//                     value={formData.confirm_password || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         confirm_password: e.target.value,
//                       })
//                     }
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Attendance Type <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={formData.attendance_type || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         attendance_type: e.target.value,
//                       })
//                     }
//                     isInvalid={!!modalErrors.attendance_type}
//                   >
//                     <option value="">Select Attendance Type...</option>
//                     <option value="Daily">Daily</option>
//                     <option value="Hourly">Hourly</option>
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.attendance_type}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>
//                     Date Of Joining <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={formData.joining_date || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, joining_date: e.target.value })
//                     }
//                     isInvalid={!!modalErrors.joining_date}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalErrors.joining_date}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Image</Form.Label>
//                   <Form.Control
//                     type="file"
//                     onChange={handleModalImageChange}
//                     accept="image/jpeg,image/png,image/gif"
//                     isInvalid={!!modalImageError}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {modalImageError}
//                   </Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Country *</Form.Label>
//                   <Form.Select
//                     value={formData.country || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, country: e.target.value })
//                     }
//                   >
//                     <option value="">Select Country...</option>
//                     <option value="India">India</option>
//                   </Form.Select>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>State *</Form.Label>
//                   <Form.Select
//                     value={formData.state || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, state: e.target.value })
//                     }
//                   >
//                     <option value="">Select State...</option>
//                     <option value="Maharashtra">Maharashtra</option>
//                     <option value="Rajasthan">Rajasthan</option>
//                     <option value="Gujarat">Gujarat</option>
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2">
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>City *</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter City"
//                     value={formData.city || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, city: e.target.value })
//                     }
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Zip Code *</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter Zip Code"
//                     value={formData.zip_code || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, zip_code: e.target.value })
//                     }
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Row className="mt-2">
//               <Col md={12}>
//                 <Form.Group>
//                   <Form.Label>Address *</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter Address"
//                     value={formData.address || ""}
//                     onChange={(e) =>
//                       setFormData({ ...formData, address: e.target.value })
//                     }
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Form>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             variant="primary"
//             style={{
//               width: "15%",
//               fontSize: "20px",
//               fontWeight: "40",
//               textAlign: "center",
//               height: "42px",
//             }}
//             onClick={() => {
//               // Rule: validate all fields before submitting
//               if (!validateModal()) return;

//               // Rule: passwords must match
//               if (formData.password !== formData.confirm_password) {
//                 alert("Password and Confirm Password must match ❌");
//                 return;
//               }

//               // Remove unwanted fields before sending
//               const { company_id, confirm_password, ...payload } = formData;

//               api
//                 .post("/api/add/employees", payload)
//                 .then(() => {
//                   alert("Employee Added Successfully ✅");
//                   setShowModal(false);
//                   setModalErrors({});
//                   fetchEmployees();
//                 })
//                 .catch((err) => {
//                   console.error(err);
//                 });
//             }}
//           >
//             Add
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </section>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Badge,
  Modal,
  Form,
  Table,
} from "react-bootstrap";
import Breadcrumb from "app/components/Breadcrumb";
import api from "app/services/api";
import "./EmployeeTable.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// ─── Validation helpers ────────────────────────────────────────────────────
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const isValidPhone = (val) => /^\d{7,15}$/.test(val.replace(/[\s\-().+]/g, ""));
const isValidDate = (val) => val && !isNaN(new Date(val).getTime());
const isNotFuture = (val) => val && new Date(val) <= new Date();
// ─────────────────────────────────────────────────────────────────────────────

// ─── Avatar helper ────────────────────────────────────────────────────────
const AVATAR_COLORS = [
  { bg: "#EDE9FE", color: "#5B21B6" },
  { bg: "#DCFCE7", color: "#166534" },
  { bg: "#FEE2E2", color: "#991B1B" },
  { bg: "#DBEAFE", color: "#1E40AF" },
  { bg: "#FEF3C7", color: "#92400E" },
  { bg: "#FCE7F3", color: "#9D174D" },
];

function getAvatarStyle(name = "") {
  const idx = name.charCodeAt(0) % AVATAR_COLORS.length;
  return AVATAR_COLORS[idx];
}
function getInitials(name = "") {
  const parts = name.trim().split(/\s+/);

  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  return name.slice(0, 2).toUpperCase();
}

// ─── Role badge colours ───────────────────────────────────────────────────
const ROLE_COLORS = {
  Developer: { bg: "#EDE9FE", color: "#5B21B6" },
  Manager: { bg: "#DCFCE7", color: "#166534" },
  Staff: { bg: "#DBEAFE", color: "#1E40AF" },
  Admin: { bg: "#FEF3C7", color: "#92400E" },
};

function RoleBadge({ role }) {
  const style = ROLE_COLORS[role] || { bg: "#F3F4F6", color: "#374151" };
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 10px",
        borderRadius: "100px",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.02em",
        background: style.bg,
        color: style.color,
      }}
    >
      {role}
    </span>
  );
}

// ─── Icon-only action button ──────────────────────────────────────────────
function ActionBtn({ color, icon, label, onClick }) {
  return (
    <button
      title={label}
      aria-label={label}
      onClick={onClick}
      style={{
        width: 30,
        height: 30,
        borderRadius: 6,
        border: "none",
        background: color,
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        fontSize: 14,
        flexShrink: 0,
        transition: "opacity 0.15s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <i className={icon}></i>
    </button>
  );
}

// ─── Form field helpers for modal ────────────────────────────────────────
function FieldGroup({ label, required, error, children }) {
  return (
    <Form.Group>
      <Form.Label style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>
        {label} {required && <span style={{ color: "#dc2626" }}>*</span>}
      </Form.Label>
      {children}
      {error && (
        <div style={{ fontSize: 11, color: "#dc2626", marginTop: 3 }}>
          {error}
        </div>
      )}
    </Form.Group>
  );
}

// ─── Section divider for modal ────────────────────────────────────────────
function ModalSection({ title }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        margin: "20px 0 12px",
      }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#7C3AED",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </span>
      <div style={{ flex: 1, height: 1, background: "#E5E7EB" }} />
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────

export default function EmployeeTable() {
  const navigate = useNavigate();

  // ── Data states ──────────────────────────────────────────────────────────
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [locations, setLocations] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [roles, setRoles] = useState([]);

  // ── UI states ────────────────────────────────────────────────────────────
  const [showModal, setShowModal] = useState(false);
  const [showEyeMenu, setShowEyeMenu] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [showCheckbox, setShowCheckbox] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  // Column filter modal state
  const [showColFilterModal, setShowColFilterModal] = useState(false);
  const [activeCol, setActiveCol] = useState(null); // 'department' | 'designation' | 'role'
  const [tempColSelections, setTempColSelections] = useState([]);

  // Applied filters for columns
  const [colFilters, setColFilters] = useState({
    department: [],
    designation: [],
    role: [],
  });

  // ── Column visibility ────────────────────────────────────────────────────
  const [disabledCols, setDisabledCols] = useState({
    employee: false,
    staff_id: false,
    company: false,
    department: false,
    designation: false,
    role: false,
    contact: false,
    status: false,
    action: false,
  });

  const toggleCol = (key) =>
    setDisabledCols((prev) => ({ ...prev, [key]: !prev[key] }));

  // ── Bulk modals ──────────────────────────────────────────────────────────
  const [showBulkLeaveModal, setShowBulkLeaveModal] = useState(false);
  const [showBulkSalaryModal, setShowBulkSalaryModal] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leavePolicies, setLeavePolicies] = useState([]);
  const [salaryPolicies, setSalaryPolicies] = useState([]);
  const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
  const [selectedLeavePolicy, setSelectedLeavePolicy] = useState(null);
  const [selectedSalaryPolicy, setSelectedSalaryPolicy] = useState(null);
  const [yearlyCTC, setYearlyCTC] = useState("");

  // ── Add Employee form ────────────────────────────────────────────────────
  const emptyForm = {
    first_name: "",
    last_name: "",
    staff_id: "",
    office_shift_id: "",
    email: "",
    contact_no: "",
    password: "",
    confirm_password: "",
    username: "",
    date_of_birth: "",
    gender: "",
    department_id: "",
    designation_id: "",
    role_users_id: "",
    joining_date: "",
    state: "",
    attendance_type: "",
    location_id: "",
    country: "",
    city: "",
    zip_code: "",
    address: "",
  };
  const [formData, setFormData] = useState(emptyForm);
  const [modalErrors, setModalErrors] = useState({});
  const [modalImageError, setModalImageError] = useState("");
  const [modalImageFile, setModalImageFile] = useState(null);

  // ── Effects ──────────────────────────────────────────────────────────────
  useEffect(() => {
    fetchEmployees();
    api
      .get("/api/company/all")
      .then((r) => setCompanies(r.data.data || []))
      .catch(console.error);
    api
      .get("/api/departments")
      .then((r) => setDepartments(r.data.departments || []))
      .catch(console.error);
    api
      .get("/api/office-shifts")
      .then((r) => {
        const arr = Array.isArray(r.data) ? r.data : r.data?.data || [];
        setShifts(arr);
      })
      .catch(console.error);
    api
      .get("/api/roles/all")
      .then((r) => setRoles(r.data.data || []))
      .catch(console.error);
    api
      .get("/api/geo-locations")
      .then((r) => setLocations(r.data.data || []))
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (!formData.department_id) return;
    api
      .get(`/api/designations?department_id=${formData.department_id}`)
      .then((r) => setDesignations(r.data.designations || []))
      .catch(console.error);
  }, [formData.department_id]);

  // ── Fetch helpers ────────────────────────────────────────────────────────
  const fetchEmployees = () => {
    api
      .get("/api/employees")
      .then((res) => {
        const data = res.data.data || [];

        console.log("Fetched employees:", data);

        setUsers(
          data.map((item, ind) => ({
            id: item.id,
            index: ind + 1,
            staff_id: item.staff_id || "N/A",
            employee: item.employee,
            company: item.company || "N/A",
            department: item.department || "N/A",
            designation: item.designation || "N/A",
            role: item.role || "N/A",
            contact: item.email || item.contact_no || "N/A",
            is_active: item.is_active,
          })),
        );
      })
      .catch(() => setUsers([]));
  };

  const fetchLeaveTypes = async () => {
    try {
      // Use leave-types endpoint for dropdown
      const res = await api.get("/api/leave-types");
      if (res.data?.success) setLeaveTypes(res.data.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchLeavePolicies = async () => {
    try {
      const res = await api.get("/api/leave-policy/list");
      if (res.data?.success) setLeavePolicies(res.data.data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSalaryPolicies = async () => {
    try {
      const res = await api.get("/api/salary-policies");
      if (res.data?.success) setSalaryPolicies(res.data.data);
    } catch (e) {
      console.error(e);
    }
  };

  // ── Actions ──────────────────────────────────────────────────────────────
  const handleDelete = (item) => {
    if (!window.confirm(`Delete "${item.employee}"?`)) return;
    api
      .delete(`/api/employees/${item.id}`)
      .then(() => fetchEmployees())
      .catch(console.error);
  };

  const handleBulkDelete = () => {
    if (!selectedRows.length) return;
    if (!window.confirm(`Delete ${selectedRows.length} employees?`)) return;
    api
      .post("/api/employees/delete", { ids: selectedRows })
      .then(() => {
        setSelectedRows([]);
        setShowCheckbox(false);
        fetchEmployees();
      })
      .catch(console.error);
  };

  const handleToggleStatus = async (item) => {
    try {
      const newStatus = item.is_active === 1 ? 0 : 1;
      await api.put(`/api/employees/${item.id}/status`, {
        is_active: newStatus,
      });
      setUsers((prev) =>
        prev.map((u) =>
          u.id === item.id ? { ...u, is_active: newStatus } : u,
        ),
      );
    } catch (e) {
      console.error(e);
    }
  };

  const openBulkLeaveModal = () => {
    if (!selectedRows.length) {
      alert("Select at least 1 employee first.");
      return;
    }
    fetchLeavePolicies();
    setSelectedLeavePolicy(null);
    setShowBulkLeaveModal(true);
  };

  const openBulkSalaryModal = () => {
    if (!selectedRows.length) {
      alert("Select at least 1 employee first.");
      return;
    }
    fetchSalaryPolicies();
    setShowBulkSalaryModal(true);
  };

  const handleApplyLeavePolicy = async () => {
    if (!selectedLeavePolicy) {
      alert("Select a leave policy.");
      return;
    }
    try {
      // Use new bulk assign API
      await api.post("/api/leave-policy/bulk-assign", {
        policy_id: selectedLeavePolicy,
        employee_ids: selectedRows,
        assigned_by: 1, // TODO: Get from auth context
      });
      alert(`Leave policy assigned to ${selectedRows.length} employees ✅`);
      setShowBulkLeaveModal(false);
      setSelectedLeavePolicy(null);
      setShowCheckbox(false);
      setSelectedRows([]);
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.message || "Failed to assign leave policy ❌");
    }
  };

  const handleApplySalaryPolicy = async () => {
    if (!selectedSalaryPolicy && !yearlyCTC) {
      alert("Enter yearly CTC or select a policy.");
      return;
    }
    try {
      // Send yearly CTC directly - backend will divide by 12
      await Promise.all(
        selectedRows.map((empId) =>
          api.put(`/api/employees/${empId}/salary`, {
            yearly_ctc: Number(yearlyCTC),
            salary_policy_id: selectedSalaryPolicy,
          }),
        ),
      );
      alert(`Salary assigned to ${selectedRows.length} employees ✅`);
      setShowBulkSalaryModal(false);
      setSelectedSalaryPolicy(null);
      setYearlyCTC("");
      setShowCheckbox(false);
      setSelectedRows([]);
    } catch (e) {
      console.error(e);
      alert("Failed to assign salary ❌");
    }
  };

  // ── Validation ────────────────────────────────────────────────────────────
  const validateModal = () => {
    const errs = {};
    if (!formData.first_name?.trim())
      errs.first_name = "First name is required";
    else if (formData.first_name.trim().length > 50)
      errs.first_name = "Max 50 characters";
    if (!formData.last_name?.trim()) errs.last_name = "Last name is required";
    else if (formData.last_name.trim().length > 50)
      errs.last_name = "Max 50 characters";
    if (!formData.email?.trim()) errs.email = "Email is required";
    else if (!EMAIL_REGEX.test(formData.email.trim()))
      errs.email = "Enter a valid email";
    if (formData.contact_no && !isValidPhone(formData.contact_no))
      errs.contact_no = "Phone must be 7–15 digits";
    if (!formData.username?.trim()) errs.username = "Username is required";
    else if (formData.username.trim().length < 3)
      errs.username = "At least 3 characters";
    else if (formData.username.trim().length > 50)
      errs.username = "Max 50 characters";
    if (formData.date_of_birth) {
      if (!isValidDate(formData.date_of_birth))
        errs.date_of_birth = "Enter a valid date";
      else if (!isNotFuture(formData.date_of_birth))
        errs.date_of_birth = "Cannot be a future date";
    }
    if (!formData.joining_date) errs.joining_date = "Joining date is required";
    else if (!isValidDate(formData.joining_date))
      errs.joining_date = "Enter a valid date";
    else if (new Date(formData.joining_date) > new Date())
      errs.joining_date = "Cannot be a future date";
    if (!formData.department_id) errs.department_id = "Department is required";
    if (!formData.designation_id)
      errs.designation_id = "Designation is required";
    if (!formData.office_shift_id)
      errs.office_shift_id = "Office shift is required";
    if (!formData.role_users_id) errs.role_users_id = "Role is required";
    if (!formData.location_id) errs.location_id = "Geo location is required";
    if (!formData.gender || !["Male", "Female"].includes(formData.gender))
      errs.gender = "Please select a gender";
    if (!["Daily", "Hourly"].includes(formData.attendance_type))
      errs.attendance_type = "Please select attendance type";
    setModalErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleModalImageChange = (e) => {
    const file = e.target.files[0];
    setModalImageFile(null);
    setModalImageError("");
    if (!file) return;
    if (
      !["image/jpeg", "image/png", "image/gif", "image/jpg"].includes(file.type)
    ) {
      setModalImageError("Only jpg, jpeg, png, gif allowed");
      e.target.value = "";
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setModalImageError("Image must be less than 5 MB");
      e.target.value = "";
      return;
    }
    setModalImageFile(file);
  };

  const handleAddEmployee = () => {
    if (!validateModal()) return;
    if (formData.password !== formData.confirm_password) {
      alert("Passwords do not match ❌");
      return;
    }
    const { company_id, confirm_password, ...payload } = formData;
    api
      .post("/api/add/employees", payload)
      .then(() => {
        setShowModal(false);
        setFormData(emptyForm);
        setModalErrors({});
        setModalImageFile(null);
        fetchEmployees();
      })
      .catch(console.error);
  };

  // ── Filtering & pagination ────────────────────────────────────────────────
  const filteredUsers = users.filter(
    (item) =>
      item.employee?.toLowerCase().includes(search.toLowerCase()) ||
      item.company?.toLowerCase().includes(search.toLowerCase()) ||
      item.department?.toLowerCase().includes(search.toLowerCase()) ||
      item.role?.toLowerCase().includes(search.toLowerCase()),
  );
  // Apply column filters (if any selected)
  const filteredByCols = filteredUsers.filter((item) => {
    if (
      colFilters.department.length &&
      !colFilters.department.includes(item.department)
    )
      return false;
    if (
      colFilters.designation.length &&
      !colFilters.designation.includes(item.designation)
    )
      return false;
    if (colFilters.role.length && !colFilters.role.includes(item.role))
      return false;
    return true;
  });
  const finalFilteredUsers = filteredByCols;
  const totalRows = finalFilteredUsers.length;
  const totalPages =
    rowsPerPage >= totalRows ? 1 : Math.ceil(totalRows / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedUsers = finalFilteredUsers.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const allPageSelected =
    paginatedUsers.length > 0 &&
    paginatedUsers.every((u) => selectedRows.includes(u.id));

  const COLS = [
    { key: "employee", label: "Employee" },
    { key: "staff_id", label: "Staff ID" },
    { key: "company", label: "Company" },
    { key: "department", label: "Department" },
    { key: "designation", label: "Designation" },
    { key: "role", label: "Role" },
    { key: "contact", label: "Contact" },
    { key: "status", label: "Status" },
    { key: "action", label: "Action" },
  ];

  // Unique values for each column (for filter modal)
  const uniqueDepartments = useMemo(() => {
    const set = new Set(users.map((u) => u.department || "N/A"));
    return Array.from(set).filter(Boolean).sort();
  }, [users]);
  const uniqueDesignations = useMemo(() => {
    const set = new Set(users.map((u) => u.designation || "N/A"));
    return Array.from(set).filter(Boolean).sort();
  }, [users]);
  const uniqueRoles = useMemo(() => {
    const set = new Set(users.map((u) => u.role || "N/A"));
    return Array.from(set).filter(Boolean).sort();
  }, [users]);

  const openColumnFilter = (col) => {
    setActiveCol(col);
    setTempColSelections(colFilters[col] ? [...colFilters[col]] : []);
    setShowColFilterModal(true);
  };

  const toggleTempSelection = (val) => {
    setTempColSelections((prev) =>
      prev.includes(val) ? prev.filter((v) => v !== val) : [...prev, val],
    );
  };

  const applyColumnFilter = () => {
    setColFilters((prev) => ({ ...prev, [activeCol]: tempColSelections }));
    setShowColFilterModal(false);
    setActiveCol(null);
    setCurrentPage(1);
  };

  const clearColumnFilter = () => {
    setColFilters((prev) => ({ ...prev, [activeCol]: [] }));
    setShowColFilterModal(false);
    setActiveCol(null);
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const excelData = finalFilteredUsers.map((emp) => ({
      "Staff ID": emp.id,
      Employee: emp.employee,
      Company: emp.company,
      Department: emp.department,
      Designation: emp.designation,
      Role: emp.role,
      Contact: emp.contact,
      Status: emp.is_active ? "Active" : "Inactive",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Employees.xlsx");
  };

  // ────────────────────────────────────────────────────────────────────────
  return (
    <section className="et-page">
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Employee", path: "/employees/EmployeesList" },
          { name: "Employee List" },
        ]}
      />

      {/* ── Toolbar card ─────────────────────────────────────────────────── */}
      <Card className="et-card mb-3">
        <Card.Body className="py-3 px-4">
          <div className="et-toolbar">
            {/* Left: primary actions */}
            <div className="et-btn-group">
              <button
                className="et-btn et-btn-purple"
                onClick={() => setShowModal(true)}
              >
                <i className="i-Business-Mens"></i>
                Add employee
              </button>
              <button
                className="et-btn et-btn-green"
                onClick={openBulkLeaveModal}
              >
                <i className="i-Checked-User"></i>
                Bulk leave
              </button>
              <button
                className="et-btn et-btn-amber"
                onClick={openBulkSalaryModal}
              >
                <i className="i-Money-2"></i>
                Bulk salary
              </button>
            </div>

            {/* Right: utility actions */}
            <div className="et-btn-group">
              <button
                className="et-icon-btn"
                title="Export PDF"
                aria-label="Export PDF"
                style={{ color: "#dc2626" }}
              >
                <i className="i-File-Horizontal-Text"></i>
              </button>
              <button
                className="et-icon-btn"
                title="Export CSV"
                aria-label="Export CSV"
                style={{ color: "#d97706" }}
                onClick={exportToExcel}
              >
                <i className="i-File-CSV"></i>
              </button>
              <button
                className="et-icon-btn"
                title="Print"
                aria-label="Print"
                style={{ color: "#2563eb" }}
              >
                <i className="i-Billing"></i>
              </button>

              <div
                style={{
                  width: 1,
                  height: 24,
                  background: "#E5E7EB",
                  margin: "0 4px",
                }}
              />

              {/* Column visibility toggle */}
              <div style={{ position: "relative" }}>
                <button
                  className="et-icon-btn"
                  style={{ gap: 4, paddingRight: 8 }}
                  onClick={() => setShowEyeMenu((v) => !v)}
                  aria-label="Toggle columns"
                >
                  <i className="i-Eye"></i>
                  <i className="i-Arrow-Down" style={{ fontSize: 10 }}></i>
                </button>
                {showEyeMenu && (
                  <div className="et-col-menu">
                    {COLS.map((c) => (
                      <label key={c.key} className="et-col-item">
                        <input
                          type="checkbox"
                          checked={!disabledCols[c.key]}
                          onChange={() => toggleCol(c.key)}
                          style={{ marginRight: 8 }}
                        />
                        {c.label}
                      </label>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Filter row */}
          {showFilter && (
            <div className="et-filter-row mt-3">
              <Form.Select onChange={(e) => {}}>
                <option value="">Company...</option>
                {companies.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.company_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Select onChange={(e) => {}}>
                <option value="">Department...</option>
                {departments.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.department_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Select onChange={(e) => {}}>
                <option value="">Designation...</option>
                {designations.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.designation_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Select onChange={(e) => {}}>
                <option value="">Shift...</option>
                {shifts.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.shift_name}
                  </option>
                ))}
              </Form.Select>
              <Button variant="dark" style={{ height: 36, padding: "0 20px" }}>
                Search
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* ── Table card ───────────────────────────────────────────────────── */}
      <Card className="et-card">
        <Card.Body className="p-0">
          {/* Table header bar */}
          <div className="et-table-header">
            <span className="et-table-title">
              Employees
              <span className="et-count">{totalRows}</span>
            </span>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <div className="et-search-wrap">
                <i className="i-Search"></i>
                <input
                  className="et-search-input"
                  type="text"
                  placeholder="Search employees…"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
              <button
                className={`et-btn ${showCheckbox ? "et-btn-outline-red" : "et-btn-outline"}`}
                style={{ height: 34, fontSize: 12, padding: "0 12px" }}
                onClick={() => {
                  setShowCheckbox((v) => !v);
                  setSelectedRows([]);
                }}
              >
                {showCheckbox ? "Cancel" : "Select"}
              </button>
              {showCheckbox && selectedRows.length > 0 && (
                <button
                  className="et-btn et-btn-red"
                  style={{ height: 34, fontSize: 12, padding: "0 12px" }}
                  onClick={handleBulkDelete}
                >
                  Delete {selectedRows.length}
                </button>
              )}
            </div>
          </div>

          {/* Selected info bar */}
          {showCheckbox && selectedRows.length > 0 && (
            <div className="et-selected-bar">
              <i className="i-Check text-white me-2"></i>
              {selectedRows.length} employee{selectedRows.length > 1 ? "s" : ""}{" "}
              selected
            </div>
          )}

          {/* Table */}
          <div style={{ overflowX: "auto" }}>
            <table className="et-table">
              <thead>
                <tr>
                  {showCheckbox && (
                    <th style={{ width: 40 }}>
                      <input
                        type="checkbox"
                        checked={allPageSelected}
                        onChange={(e) => {
                          if (e.target.checked)
                            setSelectedRows(paginatedUsers.map((u) => u.id));
                          else setSelectedRows([]);
                        }}
                        className="et-checkbox"
                        aria-label="Select all on page"
                      />
                    </th>
                  )}
                  <th style={{ width: 48 }}>#</th>
                  {!disabledCols.employee && <th>Employee</th>}
                  {!disabledCols.staff_id && <th>Staff ID</th>}
                  {!disabledCols.company && <th>Company</th>}
                  {!disabledCols.department && (
                    <th>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span>Department</span>
                        <button
                          className="et-icon-btn"
                          title="Filter department"
                          aria-label="Filter department"
                          onClick={() => openColumnFilter("department")}
                          style={{
                            padding: 6,
                            height: 28,
                            color:
                              colFilters.department.length > 0
                                ? "#7C3AED"
                                : "#6B7280",
                            background:
                              colFilters.department.length > 0
                                ? "#EDE9FE"
                                : "#F3F4F6",
                            borderRadius: 6,
                          }}
                        >
                          <i className="i-Filter"></i>
                        </button>
                        {colFilters.department.length > 0 && (
                          <span
                            style={{
                              background: "#F3F4F6",
                              color: "#374151",
                              padding: "2px 6px",
                              borderRadius: 6,
                              fontSize: 12,
                            }}
                          >
                            {colFilters.department.length}
                          </span>
                        )}
                      </div>
                    </th>
                  )}
                  {!disabledCols.designation && (
                    <th>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span>Designation</span>
                        <button
                          className="et-icon-btn"
                          title="Filter designation"
                          aria-label="Filter designation"
                          onClick={() => openColumnFilter("designation")}
                          style={{ padding: 6, height: 28 }}
                        >
                          <i className="i-Filter"></i>
                        </button>
                        {colFilters.designation.length > 0 && (
                          <span
                            style={{
                              background: "#F3F4F6",
                              color: "#374151",
                              padding: "2px 6px",
                              borderRadius: 6,
                              fontSize: 12,
                            }}
                          >
                            {colFilters.designation.length}
                          </span>
                        )}
                      </div>
                    </th>
                  )}
                  {!disabledCols.role && (
                    <th>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span>Role</span>
                        <button
                          className="et-icon-btn"
                          title="Filter role"
                          aria-label="Filter role"
                          onClick={() => openColumnFilter("role")}
                          style={{ padding: 6, height: 28 }}
                        >
                          <i className="i-Filter"></i>
                        </button>
                        {colFilters.role.length > 0 && (
                          <span
                            style={{
                              background: "#F3F4F6",
                              color: "#374151",
                              padding: "2px 6px",
                              borderRadius: 6,
                              fontSize: 12,
                            }}
                          >
                            {colFilters.role.length}
                          </span>
                        )}
                      </div>
                    </th>
                  )}
                  {!disabledCols.contact && <th>Contact</th>}
                  {!disabledCols.status && <th>Status</th>}
                  {!disabledCols.action && (
                    <th style={{ width: 140 }}>Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedUsers.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="et-empty">
                      <i
                        className="i-Search"
                        style={{
                          fontSize: 28,
                          opacity: 0.3,
                          display: "block",
                          marginBottom: 8,
                        }}
                      ></i>
                      No employees found
                    </td>
                  </tr>
                ) : (
                  paginatedUsers.map((item, index) => {
                    const avatarStyle = getAvatarStyle(item.employee || "");
                    return (
                      <tr
                        key={item.id}
                        className={
                          selectedRows.includes(item.id)
                            ? "et-row-selected"
                            : ""
                        }
                      >
                        {showCheckbox && (
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(item.id)}
                              onChange={(e) => {
                                if (e.target.checked)
                                  setSelectedRows((p) => [...p, item.id]);
                                else
                                  setSelectedRows((p) =>
                                    p.filter((id) => id !== item.id),
                                  );
                              }}
                              className="et-checkbox"
                              aria-label={`Select ${item.employee}`}
                            />
                          </td>
                        )}
                        <td className="et-num">{startIndex + index + 1}</td>

                        {!disabledCols.employee && (
                          <td>
                            <div className="et-emp-cell">
                              <div
                                className="et-avatar"
                                style={{
                                  background: avatarStyle.bg,
                                  color: avatarStyle.color,
                                }}
                              >
                                {getInitials(item.employee)}
                              </div>
                              <div>
                                <div className="et-emp-name">
                                  {item.employee}
                                </div>
                                <div className="et-emp-sub">
                                  {item.contact}{" "}
                                </div>
                              </div>
                            </div>
                          </td>
                        )}
                        {!disabledCols.staff_id && <td>{item.id}</td>}

                        {!disabledCols.company && (
                          <td className="et-cell-muted">{item.company}</td>
                        )}
                        {!disabledCols.department && <td>{item.department}</td>}
                        {!disabledCols.designation && (
                          <td className="et-cell-muted">{item.designation}</td>
                        )}
                        {!disabledCols.role && (
                          <td>
                            <RoleBadge role={item.role} />
                          </td>
                        )}
                        {!disabledCols.contact && (
                          <td className="et-cell-muted">{item.contact}</td>
                        )}

                        {!disabledCols.status && (
                          <td>
                            <div className="et-status-wrap">
                              <Form.Check
                                type="switch"
                                id={`status-${item.id}`}
                                checked={item.is_active === 1}
                                onChange={() => handleToggleStatus(item)}
                                aria-label={`Toggle status for ${item.employee}`}
                              />
                              <span
                                className="et-status-label"
                                style={{
                                  color:
                                    item.is_active === 1
                                      ? "#16a34a"
                                      : "#9CA3AF",
                                }}
                              >
                                {item.is_active === 1 ? "Active" : "Inactive"}
                              </span>
                            </div>
                          </td>
                        )}

                        {!disabledCols.action && (
                          <td>
                            <div style={{ display: "flex", gap: 6 }}>
                              <ActionBtn
                                color="#7C3AED"
                                icon="i-Edit"
                                label={`Edit ${item.employee}`}
                                onClick={() =>
                                  navigate(`/employees/${item.id}/general`, {
                                    state: item,
                                  })
                                }
                              />
                              <ActionBtn
                                color="#dc2626"
                                icon="i-Close-Window"
                                label={`Delete ${item.employee}`}
                                onClick={() => handleDelete(item)}
                              />
                              <ActionBtn
                                color="#d97706"
                                icon="i-File-Horizontal-Text"
                                label={`PDF for ${item.employee}`}
                                onClick={() => alert("PDF for ID: " + item.id)}
                              />
                              <ActionBtn
                                color="#2563eb"
                                icon="i-Map-Marker"
                                label={`Map for ${item.employee}`}
                                onClick={() => alert("Map for ID: " + item.id)}
                              />
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="et-pagination">
            <div className="et-pagination-left">
              <span className="et-pg-label">Rows per page</span>
              <select
                className="et-pg-select"
                value={rowsPerPage}
                onChange={(e) => {
                  const val =
                    e.target.value === "all"
                      ? filteredUsers.length
                      : Number(e.target.value);

                  setRowsPerPage(val);
                  setCurrentPage(1);
                }}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value="all">All</option>
              </select>
              <span className="et-pg-info">
                {totalRows === 0 ? "0" : startIndex + 1}–
                {Math.min(startIndex + rowsPerPage, totalRows)} of {totalRows}
              </span>
            </div>
            <div style={{ display: "flex", gap: 4 }}>
              {[
                {
                  label: "⏮",
                  title: "First",
                  onClick: () => setCurrentPage(1),
                  disabled: currentPage === 1,
                },
                {
                  label: "◀",
                  title: "Previous",
                  onClick: () => setCurrentPage((p) => p - 1),
                  disabled: currentPage === 1,
                },
                {
                  label: "▶",
                  title: "Next",
                  onClick: () => setCurrentPage((p) => p + 1),
                  disabled: currentPage >= totalPages,
                },
                {
                  label: "⏭",
                  title: "Last",
                  onClick: () => setCurrentPage(totalPages),
                  disabled: currentPage >= totalPages,
                },
              ].map((btn) => (
                <button
                  key={btn.title}
                  className="et-pg-btn"
                  title={btn.title}
                  aria-label={btn.title}
                  disabled={btn.disabled}
                  onClick={btn.onClick}
                >
                  {btn.label}
                </button>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* ═══════════════════════════════════════════════════════════════════
          ADD EMPLOYEE MODAL
      ═══════════════════════════════════════════════════════════════════ */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="et-modal-header">
          <Modal.Title className="et-modal-title">Add employee</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "8px 28px 16px" }}>
          <ModalSection title="Personal info" />
          <Row className="g-3">
            <Col md={6}>
              <FieldGroup
                label="First name"
                required
                error={modalErrors.first_name}
              >
                <Form.Control
                  placeholder="First name"
                  value={formData.first_name}
                  onChange={(e) =>
                    setFormData({ ...formData, first_name: e.target.value })
                  }
                  isInvalid={!!modalErrors.first_name}
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Last name"
                required
                error={modalErrors.last_name}
              >
                <Form.Control
                  placeholder="Last name"
                  value={formData.last_name}
                  onChange={(e) =>
                    setFormData({ ...formData, last_name: e.target.value })
                  }
                  isInvalid={!!modalErrors.last_name}
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Staff ID">
                <Form.Control
                  placeholder="e.g. EMP-001"
                  value={formData.staff_id || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, staff_id: e.target.value })
                  }
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Email" required error={modalErrors.email}>
                <Form.Control
                  type="email"
                  placeholder="name@company.com"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  isInvalid={!!modalErrors.email}
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Phone" error={modalErrors.contact_no}>
                <Form.Control
                  placeholder="+91 98XXX XXXXX"
                  value={formData.contact_no}
                  onChange={(e) =>
                    setFormData({ ...formData, contact_no: e.target.value })
                  }
                  isInvalid={!!modalErrors.contact_no}
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Date of birth"
                error={modalErrors.date_of_birth}
              >
                <Form.Control
                  type="date"
                  value={formData.date_of_birth}
                  onChange={(e) =>
                    setFormData({ ...formData, date_of_birth: e.target.value })
                  }
                  isInvalid={!!modalErrors.date_of_birth}
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Gender" required error={modalErrors.gender}>
                <Form.Select
                  value={formData.gender}
                  onChange={(e) =>
                    setFormData({ ...formData, gender: e.target.value })
                  }
                  isInvalid={!!modalErrors.gender}
                >
                  <option value="">Select gender…</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Profile image" error={modalImageError}>
                <Form.Control
                  type="file"
                  accept="image/jpeg,image/png,image/gif"
                  onChange={handleModalImageChange}
                  isInvalid={!!modalImageError}
                />
              </FieldGroup>
            </Col>
          </Row>

          <ModalSection title="Work details" />
          <Row className="g-3">
            <Col md={6}>
              <FieldGroup
                label="Department"
                required
                error={modalErrors.department_id}
              >
                <Form.Select
                  value={formData.department_id}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      department_id: e.target.value,
                      designation_id: "",
                    })
                  }
                  isInvalid={!!modalErrors.department_id}
                >
                  <option value="">Select department…</option>
                  {departments.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.department_name}
                    </option>
                  ))}
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Designation"
                required
                error={modalErrors.designation_id}
              >
                <Form.Select
                  value={formData.designation_id}
                  onChange={(e) =>
                    setFormData({ ...formData, designation_id: e.target.value })
                  }
                  isInvalid={!!modalErrors.designation_id}
                  disabled={!formData.department_id}
                >
                  <option value="">Select designation…</option>
                  {designations.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.designation_name}
                    </option>
                  ))}
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Office shift"
                required
                error={modalErrors.office_shift_id}
              >
                <Form.Select
                  value={formData.office_shift_id}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      office_shift_id: e.target.value,
                    })
                  }
                  isInvalid={!!modalErrors.office_shift_id}
                >
                  <option value="">Select shift…</option>
                  {shifts.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.shift_name}
                    </option>
                  ))}
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Role"
                required
                error={modalErrors.role_users_id}
              >
                <Form.Select
                  value={formData.role_users_id}
                  onChange={(e) =>
                    setFormData({ ...formData, role_users_id: e.target.value })
                  }
                  isInvalid={!!modalErrors.role_users_id}
                >
                  <option value="">Select role…</option>
                  {roles.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Attendance type"
                required
                error={modalErrors.attendance_type}
              >
                <Form.Select
                  value={formData.attendance_type}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      attendance_type: e.target.value,
                    })
                  }
                  isInvalid={!!modalErrors.attendance_type}
                >
                  <option value="">Select type…</option>
                  <option value="Daily">Daily</option>
                  <option value="Hourly">Hourly</option>
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Date of joining"
                required
                error={modalErrors.joining_date}
              >
                <Form.Control
                  type="date"
                  value={formData.joining_date}
                  onChange={(e) =>
                    setFormData({ ...formData, joining_date: e.target.value })
                  }
                  isInvalid={!!modalErrors.joining_date}
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup
                label="Geo location"
                required
                error={modalErrors.location_id}
              >
                <Form.Select
                  value={formData.location_id}
                  onChange={(e) =>
                    setFormData({ ...formData, location_id: e.target.value })
                  }
                  isInvalid={!!modalErrors.location_id}
                >
                  <option value="">Select location…</option>
                  {locations.map((l) => (
                    <option key={l.value} value={l.value}>
                      {l.label}
                    </option>
                  ))}
                </Form.Select>
              </FieldGroup>
            </Col>
          </Row>

          <ModalSection title="Account" />
          <Row className="g-3">
            <Col md={6}>
              <FieldGroup
                label="Username"
                required
                error={modalErrors.username}
              >
                <Form.Control
                  placeholder="Username"
                  value={formData.username}
                  onChange={(e) =>
                    setFormData({ ...formData, username: e.target.value })
                  }
                  isInvalid={!!modalErrors.username}
                />
              </FieldGroup>
            </Col>
            <Col md={6} />
            <Col md={6}>
              <FieldGroup label="Password" required>
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Confirm password" required>
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={formData.confirm_password}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      confirm_password: e.target.value,
                    })
                  }
                />
              </FieldGroup>
            </Col>
          </Row>

          <ModalSection title="Address" />
          <Row className="g-3">
            <Col md={6}>
              <FieldGroup label="Country">
                <Form.Select
                  value={formData.country || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, country: e.target.value })
                  }
                >
                  <option value="">Select country…</option>
                  <option value="India">India</option>
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="State">
                <Form.Select
                  value={formData.state || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, state: e.target.value })
                  }
                >
                  <option value="">Select state…</option>
                  <option value="Maharashtra">Maharashtra</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Gujarat">Gujarat</option>
                </Form.Select>
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="City">
                <Form.Control
                  placeholder="Enter city"
                  value={formData.city || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, city: e.target.value })
                  }
                />
              </FieldGroup>
            </Col>
            <Col md={6}>
              <FieldGroup label="Zip code">
                <Form.Control
                  placeholder="Enter zip code"
                  value={formData.zip_code || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, zip_code: e.target.value })
                  }
                />
              </FieldGroup>
            </Col>
            <Col md={12}>
              <FieldGroup label="Address">
                <Form.Control
                  placeholder="Enter full address"
                  value={formData.address || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, address: e.target.value })
                  }
                />
              </FieldGroup>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="et-modal-footer">
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <button className="et-btn et-btn-purple" onClick={handleAddEmployee}>
            <i className="i-Business-Mens"></i>
            Add employee
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════════════════════════════
          BULK LEAVE MODAL
      ═══════════════════════════════════════════════════════════════════ */}
      <Modal
        show={showBulkLeaveModal}
        onHide={() => setShowBulkLeaveModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton className="et-modal-header">
          <Modal.Title className="et-modal-title">
            Apply leave policy
            <span className="et-modal-badge">
              {selectedRows.length} employees
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "16px 24px" }}>
          <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 14 }}>
            Select a leave policy to assign to the selected employees:
          </p>
          {leavePolicies.length === 0 ? (
            <div className="et-loading">Loading leave policies…</div>
          ) : (
            <Form.Select
              value={selectedLeavePolicy || ""}
              onChange={(e) =>
                setSelectedLeavePolicy(
                  e.target.value ? parseInt(e.target.value) : null,
                )
              }
              style={{ marginBottom: 16 }}
            >
              <option value="">Select a policy...</option>
              {leavePolicies.map((policy) => (
                <option key={policy.id} value={policy.id}>
                  {policy.title} (Level {policy.level}) -{" "}
                  {policy.components?.length || 0} leave types
                </option>
              ))}
            </Form.Select>
          )}

          {selectedLeavePolicy && (
            <div
              style={{
                background: "#f8f9fa",
                padding: 12,
                borderRadius: 8,
                marginTop: 8,
              }}
            >
              <p
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  marginBottom: 8,
                  color: "#663399",
                }}
              >
                Policy Details:
              </p>
              {leavePolicies
                .find((p) => p.id === selectedLeavePolicy)
                ?.components?.map((comp, i) => (
                  <div
                    key={i}
                    style={{
                      fontSize: 12,
                      marginBottom: 4,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{comp.leave_type}</span>
                    <span style={{ color: "#6B7280" }}>
                      {comp.allocated_days} days{" "}
                      {comp.is_paid ? "(Paid)" : "(Unpaid)"}
                    </span>
                  </div>
                ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="et-modal-footer">
          <Button variant="light" onClick={() => setShowBulkLeaveModal(false)}>
            Cancel
          </Button>
          <button
            className="et-btn et-btn-green"
            onClick={handleApplyLeavePolicy}
            disabled={!selectedLeavePolicy}
          >
            <i className="i-Checked-User"></i>
            Apply leave policy
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════════════════════════════
          BULK SALARY MODAL
      ═══════════════════════════════════════════════════════════════════ */}
      <Modal
        show={showBulkSalaryModal}
        onHide={() => setShowBulkSalaryModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton className="et-modal-header">
          <Modal.Title className="et-modal-title">
            Apply salary
            <span className="et-modal-badge">
              {selectedRows.length} employees
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "16px 24px" }}>
          <Row className="g-3">
            <Col md={12}>
              <FieldGroup label="Yearly CTC (₹)" required>
                <Form.Control
                  type="number"
                  placeholder="e.g. 600000"
                  value={yearlyCTC}
                  onChange={(e) => setYearlyCTC(e.target.value)}
                />
                {yearlyCTC && (
                  <Form.Text className="text-muted">
                    ≈ ₹
                    {Number(yearlyCTC / 12).toLocaleString("en-IN", {
                      maximumFractionDigits: 2,
                    })}{" "}
                    per month
                  </Form.Text>
                )}
              </FieldGroup>
            </Col>
            <Col md={12}>
              <FieldGroup label="Salary policy (optional)">
                <Form.Select
                  value={selectedSalaryPolicy || ""}
                  onChange={(e) =>
                    setSelectedSalaryPolicy(e.target.value || null)
                  }
                >
                  <option value="">No policy selected</option>
                  {salaryPolicies.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.title}
                    </option>
                  ))}
                </Form.Select>
              </FieldGroup>
            </Col>
          </Row>
          <div className="et-info-note mt-3">
            <i className="i-Information"></i>
            Yearly CTC is required. System will calculate monthly gross (CTC ÷
            12). Policy is optional for future reference.
          </div>
        </Modal.Body>
        <Modal.Footer className="et-modal-footer">
          <Button variant="light" onClick={() => setShowBulkSalaryModal(false)}>
            Cancel
          </Button>
          <button
            className="et-btn et-btn-amber"
            onClick={handleApplySalaryPolicy}
            disabled={!yearlyCTC}
          >
            <i className="i-Money-2"></i>
            Apply salary
          </button>
        </Modal.Footer>
      </Modal>
      {/* Column filter modal */}
      <Modal
        show={showColFilterModal}
        onHide={() => setShowColFilterModal(false)}
        size="sm"
        centered
      >
        <Modal.Header closeButton className="et-modal-header">
          <Modal.Title className="et-modal-title">
            Filter {activeCol}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "12px 20px" }}>
          <div style={{ maxHeight: 240, overflowY: "auto" }}>
            {(activeCol === "department"
              ? uniqueDepartments
              : activeCol === "designation"
                ? uniqueDesignations
                : uniqueRoles
            ).map((opt) => (
              <Form.Check
                key={opt}
                type="checkbox"
                id={`col-filter-${activeCol}-${opt}`}
                label={opt}
                checked={tempColSelections.includes(opt)}
                onChange={() => toggleTempSelection(opt)}
                style={{ marginBottom: 8 }}
              />
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="et-modal-footer">
          <Button
            variant="light"
            onClick={() => {
              setShowColFilterModal(false);
              setActiveCol(null);
            }}
          >
            Cancel
          </Button>
          <Button variant="outline-secondary" onClick={clearColumnFilter}>
            Clear
          </Button>
          <button className="et-btn et-btn-green" onClick={applyColumnFilter}>
            Apply
          </button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}
